module.exports = __webpack_public_path__ + "img/manage-1.c0bded9f.png";